let plugin = {
  
  // 时间戳转换为2018-09-22格式
  formatDateTime (inputTime, format) {
    let times = ''
    if (inputTime) {
      let date = new Date(inputTime)
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      let minute = date.getMinutes()
      let second = date.getSeconds()
      minute = minute < 10 ? ('0' + minute) : minute
      second = second < 10 ? ('0' + second) : second
      // times = y + '-' + m + '-' + d + ' ' + h + ':' + minute // +':'+second
      if (format == 1) {
        times = h + ':' + minute
      } else {
        times = y + '-' + m + '-' + d
      }
    }

    return times
  },
  GameTypeData:[
    {
      label: '国内室内运动会',
      value: 4
    },
    {
      label: '国内一般运动会',
      value: 3
    },
    {
      label: '国际一般运动会',
      value: 0
    },
    {
      label: '国际室内运动会',
      value: 1
    }],
    GameTypeData1:[
      {
        label: '国内',
        value: 1
      },
      {
        label: '国际',
        value: 0
      },
      ],
    GameTypeData2:[
        {
          label: '室内赛',
          value: 1
        },
        {
          label: '场地赛',
          value: 0
        },
        {
          label: '竞走',
          value: 2
        },
        {
          label: '越野',
          value: 3
        },
        {
          label: '马拉松',
          value: 4
        },
        {
          label: '综合',
          value: 5
        },
        {
          label: '其它',
          value: -1
        },
      ],
      GameTypeData3:[
        {
          label: 'OW',
          value: 'OW'
        },
        {
          label: 'DF',
          value: 'DF'
        },
        {
          label: 'GW',
          value: 'GW'
        },
        {
          label: 'GL',
          value: 'GL'
        },
        {
          label: 'A',
          value: 'A'
        },
        {
          label: 'B',
          value: 'B'
        }, 
        {
          label: 'C',
          value: 'C'
        },
        {
          label: 'D',
          value: 'D'
        },
        {
          label: 'E',
          value: 'E'
        }, 
        {
          label: 'F',
          value: 'F'
        },
      ],
    getSortName(num)
    {
        let str = '';
        if(num || num===0)
        {
          switch(num)
          {
              case 0:
                  str =  "成年组"
                  break;
              case 1:
                  str =  "青年组"
                  break;
              case 2:
                  str =  "少年组"
                  break;
          }
          
        }
        return str;
    },
  SortNameENGData:[
    {
      label: '成年组',
      value: 0
    },
    {
      label: '青年组',
      value: 1
    },
    {
      label: '少年组',
      value: 2
    },
  ],
  getAmeType(num)
  {
      // '运动会类型，
      // 0：国际一般运动会，
      // 1：国际室内运动会
      // 2：国际残疾人运动会
      // 3：国内一般运动会，
      // 4：国内室内运动会，
      // 5：国内残疾人运动会
      let str = '';
      if(num || num===0)
      {
        switch(num)
        {
            case 0:
                str =  "国际一般运动会"
                break;
            case 1:
                str =  "国际室内运动会"
                break;
            case 3:
                str =  "国内一般运动会"
                break;
            case 4:
                str =  "国内室内运动会"
                break;
        }
        return str;
      }
      
    },
    sexData:[
      {
        label: '男子',
        value: 0
      },
      {
        label: '女子',
        value: 1
      },
      {
        label: '混合',
        value: 2
      },
    ],
    highJumData:[
      {
        label: 'X',
        value: 'X'
      },
      {
        label: '-',
        value: '-'
      },
      {
        label: 'O',
        value: 'O'
      },
      {
        label: 'r',
        value: 'r'
      },
    ],
    sexType(num)
    {
      // '性别，0-男子，1-女子，2-混合'
      let str = '';
      if(num || num===0)
      {
        switch(num)
        {
            case 0:
                str =  "男子"
                break;
            case 1:
                str =  "女子"
                break;
            case 2:
                str =  "混合"
                break;
            
        }
      }
        return str;
    },
    speedData:[
      {
        label: '无',
        value: 0
      },
      {
        label: '有',
        value: 1
      },
    ],

    layerNameData:[
      {
        label: '预赛',
        value: 0
      },
      {
        label: '及格赛',
        value: 1
      },
      {
        label: '决赛',
        value: 2
      },
 
    ],
    
    allEvent1:[
      {
        label: '55米',
        value: 1,
        allNum:1
      },
      {
        label: '60米',
        value: 1,
        allNum:2
      },
      {
        label: '100米',
        value: 1,
        allNum:3
      },
      {
        label: '200米',
        value: 1,
        allNum:4
      },
      {
        label: '400米',
        value: 1,
        allNum:5
      },
      {
        label: '1000米',
        value: 1,
        allNum:6
      },
      {
        label: '1500米',
        value: 1,
        allNum:7
      },
      {
        label: '55米栏',
        value: 1,
        allNum:8
      },
      {
        label: '60米栏',
        value: 1,
        allNum:9
      },
      {
        label: '110米栏',
        value: 1,
        allNum:10
      },
      {
        label: '跳高',
        value: 2,
        allNum:11
      },
      {
        label: '撑竿跳高',
        value: 2,
        allNum:12
      },
      {
        label: '跳远',
        value: 3,
        allNum:13
      },
      {
        label: '铅球',
        value: 3,
        allNum:14
      },
      {
        label: '铁饼',
        value: 3,
        allNum:15
      },
      {
        label: '标枪',
        value: 3,
        allNum:16
      },
    ],
    allEvent2:[
      {
        label: '55米',
        value: 1,
        allNum:1
      },
      {
        label: '60米',
        value: 1,
        allNum:2
      },
      {
        label: '100米',
        value: 1,
        allNum:3
      },
      {
        label: '200米',
        value: 1,
        allNum:4
      },
      {
        label: '800米',
        value: 1,
        allNum:5
      },
      {
        label: '55米栏',
        value: 1,
        allNum:6
      },
      {
        label: '60米栏',
        value: 1,
        allNum:7
      },
      {
        label: '100米栏',
        value: 1,
        allNum:8
      },
      {
        label: '跳高',
        value: 2,
        allNum:9
      },
      {
        label: '撑竿跳高',
        value: 2,
        allNum:10
      },
      {
        label: '跳远',
        value: 3,
        allNum:11
      },
      {
        label: '铅球',
        value: 3,
        allNum:12
      },
      {
        label: '铁饼',
        value: 3,
        allNum:13
      },
      {
        label: '标枪',
        value: 3,
        allNum:14
      },
    ],
    segmentationData:[
      {
        label: '无',
        value: 0
      },
      {
        label: '田赛',
        value: 1
      },
      {
        label: '竞赛',
        value: 2,
      },
      {
        label: '接力',
        value: 3
      },
    ],
    allEventProp:[
      {
        label: '径赛',
        value: 1
      },
      {
        label: '田高',
        value: 2
      },
      {
        label: '田远',
        value: 3
      },
     
    ],
    stateResultData:[
      {
        label: '正常',
        value: 0
      },
      {
        label: 'DQ',
        value: -1
      },
     
      {
        label: 'DNF',
        value: -2
      },
      {
        label: 'DNS',
        value: -3
      },
      {
        label: 'DR',
        value: -8
      },
      {
        label: 'DT',
        value: -9
      },
      {
        label: '末位淘汰',
        value: -10
      },
      {
        label: 'NM',
        value: -12
      },
      {
        label: 'YC',
        value: -13
      },
      {
        label: 'RC',
        value: -14
      },
    ],
    gameState:[
      {
        label: '录入中',
        value: 1
      },
      {
        label: '审核中',
        value: 2
      },
      {
        label: '审核完成',
        value: 3
      },
      {
        label: '上传历史库',
        value: 4
      },
    ],
    propertyTypeNum(eventType)
    {
      // '性别，0-男子，1-女子，2-混合'
      let str = '';
      if(eventType || eventType===0)
      {
        switch(eventType)
        {
            case 2:
                str =  "升高计划表设置"
                break;
            case 4:
                str =  "接力棒次设置"
                break;
            case 5:
                str =  "全能项目设置"
                break;
            default:
                str =  false
                break;
            
        }
      }
        return str;
    },
    speeds (str) {
      let val = String(str)
      if (val.indexOf('.') > -1) {
        var arr = val.split('.')
        arr[1].substring(0, 1)
        return arr[0] + '.' + arr[1].substring(0, 1)
      } else {
        return val
      }
    },
    /**加**/
    addCmx(arg1, arg2) {
      var r1, r2, m, c;
      try {
        r1 = arg1.toString().split(".")[1].length;
      }
      catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      }
      catch (e) {
        r2 = 0;
      }
      c = Math.abs(r1 - r2);
      m = Math.pow(10, Math.max(r1, r2));
      if (c > 0) {
        var cm = Math.pow(10, c);
        if (r1 > r2) {
          arg1 = Number(arg1.toString().replace(".", ""));
          arg2 = Number(arg2.toString().replace(".", "")) * cm;
        } else {
          arg1 = Number(arg1.toString().replace(".", "")) * cm;
          arg2 = Number(arg2.toString().replace(".", ""));
        }
      } else {
        arg1 = Number(arg1.toString().replace(".", ""));
        arg2 = Number(arg2.toString().replace(".", ""));
      }
      return (arg1 + arg2) / m;
    },
    
    /** 减**/
    subCmx (arg1, arg2) {
      var r1, r2, m, n;
      try {
        r1 = arg1.toString().split(".")[1].length;
      }
      catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      }
      catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
      n = (r1 >= r2) ? r1 : r2;
      return Number(((arg1 * m - arg2 * m) / m).toFixed(n));
    },
    
    /** 乘**/
    mulCmx(arg1, arg2) {
      var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      }
      catch (e) {
      }
      try {
        m += s2.split(".")[1].length;
      }
      catch (e) {
      }
      return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },
    /** 除**/
    divCmx (arg1, arg2) {
      var t1 = 0, t2 = 0, r1, r2;  
          try {  
              t1 = arg1.toString().split(".")[1].length;  
          }  
          catch (e) {  
          }  
          try {  
              t2 = arg2.toString().split(".")[1].length;  
          }  
          catch (e) {  
          }  
          r1 = Number(arg1.toString().replace(".", ""));  
          r2 = Number(arg2.toString().replace(".", ""));  
          return (r1 / r2) * pow(10, t2 - t1);  
    },
    deepClone (obj) {
      var result = Array.isArray(obj) ? [] : {}
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === 'object' && obj[key]) 
          {
            result[key] = this.deepClone(obj[key]) // 递归复制
          } else 
          {
            result[key] = obj[key]
          }
        }
      }
      return result
    },
    role:{
      admin:'ROLE_ADMIN',
      entryAdmin:'ROLE_INPUT_UNIT_ADMIN',
      unitEntry:'ROLE_USER',
      countriesEntry:'ROLE_INPUT_NATION',
      roleAwardAdmin:'ROLE_AWARD_ADMIN',
      print:'ROLE_AWARD_ADMIN'
    }

}

export default {
  install: function (vm) {
    vm.prototype.$PlugIn = plugin
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils/index.js